//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api';
const baseURLClassroom = '/api';
const baseURLCourse = '/api';
const baseURLCourseDistribution = '/api';
import listRequest from '../../js/listRequest.js';
import pageHelper from '../../js/pageHelper.js'; //ljx

export const accountApi = {
    //获得分页表格数据
    getList(opt: any, pageData?: any) {
        var servicesPath = baseURL + '/v1/user/list';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;

        listRequest.request({
            // isDebug:true,//本地临时数据专用
            // tempData:listData,//本地临时数据专用ds
            url: servicesPath,
            context: context,
            pager: pager,
            isShowLoading: false,
            data: {},
            urlQueryParmas: opt.urlQueryParmas || {},
            appendAttributes: opt.appendAttributes || {},
            prepareRender(data: any) {
                //如果列表需要显示编码的中文，则需要重写prepareRender
                context.$pageHelper.initListRowsCode(data.data.list, initCodeRules);
                return data;
            },
            afterRender: opt.afterRender || function() {}
        });
    },

    // 保存/新增 内容到接口表单
    saveRecord(opt: any) {
        var servicesPath = baseURL + '/v1/user';
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'POST';
        if (pageData._id != undefined && pageData._id != '') {
            ajaxType = 'PUT';
            servicesPath += '/' + pageData._id;
            delete pageData._id;
            delete pageData.roles;
        }

        delete pageData.type;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            headers: {
                'content-type': 'application/json'
            },
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    //删除老师
    deleteRecord(opt: any) {
        var servicesPath = baseURL + '/v1/user';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + opt.id;

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'DELETE' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    //初始化班级数据
    requestInitClass(opt: any) {
        var servicesPath = baseURLClassroom + '/v1/class/list';
        let context = opt.context;
        let pager = opt.pager;
        let data = opt.data;

        let urlQueryParmas = opt.urlQueryParmas;
        listRequest.request({
            context: context,
            url: servicesPath,
            // data: opt.data.id,
            urlQueryParmas: urlQueryParmas,
            success(data: any, parameters: any) {
                // console.log("初始化班级数据："+JSON.stringify(data));
                opt.success(data.data.list, opt);
            }
        });
    },

    //初始化表单输入框数据
    initForm(opt: any) {
        var servicesPath = baseURL + '/v1/user';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        let data = opt.data;
        servicesPath += '/' + data.id;
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    //获取默认密码
    getDefaultPassword(opt: any) {
        var servicesPath = baseURL + '/user';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlParamObj = opt.urlParamObj || {};
        servicesPath += '/' + urlParamObj.id;
        let data = {
            content: '123456'
        };
        opt.success(data, opt);
    },

    // 解绑手机号/重置密码
    userOperation(opt: any) {
        var servicesPath = baseURL + '/v1/user';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlQueryParmas = opt.urlParamObj || {};

        let type = 'PUT';
        // pageData.password="123456";
        if (pageData.operationType == 'mobilephone') {
            servicesPath += '/' + pageData.userId;
            delete pageData.userId;
            // delete pageData.password;
        } else {
            servicesPath = baseURL + '/v1/user/password';
            type = 'PATCH';
            delete pageData.mobile;
        }
        delete pageData.operationType;
        listRequest.request({
            context: context,
            url: servicesPath,
            data: pageData,
            // urlQueryParmas:urlQueryParmas||{},
            ajaxOpt: {
                //ajax的参数配置
                type: type //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(opt);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    //初始化课程列下拉选择数据  http://yapi.dm-ai.cn:3000/project/433/interface/api/4465
    requestInitCourse(opt: any) {
        var servicesPath = baseURLCourseDistribution + '/distribution/class';
        let context = opt.context;

        let urlQueryParmas = opt.urlQueryParmas;
        listRequest.request({
            context: context,
            url: servicesPath,
            isShowLoading: false,
            urlQueryParmas: urlQueryParmas,
            success(data: any, parameters: any) {
                // console.log("初始化已授权课程数据："+JSON.stringify(data));
                opt.success(data.data.list, opt);
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },

    //修改时 初始化该班级的课程列下拉选择数据
    eidtCourseList(opt: any) {
        var servicesPath = baseURLCourseDistribution + '/distribution/class/list';
        let context = opt.context;
        let pager = opt.pager;
        let data = opt.data;

        let urlQueryParmas = opt.urlQueryParmas;
        context.$basicRequest.request({
            context: context,
            url: servicesPath,
            data: urlQueryParmas,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            // urlQueryParmas:urlQueryParmas,
            success(data: any, parameters: any) {
                // console.log("初始化已授权课程数据："+JSON.stringify(data));
                opt.success(data.data, opt);
            }
        });
    },
    // 师生管理-授课设置授权接口（为单个老师授权班级下关联的课程）  http://yapi.dm-ai.cn:3000/project/334/interface/api/26785
    authorizeTeacher(opt: any) {
        var servicesPath = baseURL + '/v1/class/teacher/class/course';
        let context = opt.context;
        let pageData = opt.data || {};

        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '保存中，请稍等...',
            headers: {
                'content-type': 'application/json'
            },
            ajaxOpt: {
                //ajax的参数配置
                type: 'PUT' //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    // 统计用户数量  http://yapi.dm-ai.cn:3000/project/163/interface/api/27515
    getUserCount(opt: any) {
        var servicesPath = baseURL + '/v1/user/count';
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas;
        listRequest.request({
            context: context,
            url: servicesPath,
            urlQueryParmas: urlQueryParmas,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    }
};
